<template>
  <div>
    <div>
      <p class="open-sans-20pt">
        T-2 Klub
      </p>
    </div>
    <div class="postavitev-vsebine-t2-klub">
      <p class="navadno-besedilo">
        <b>
          {{ this.nazivStranke }}, postanite član/-ica T-2 Kluba že danes!
        </b>
      </p>
      <p class="navadno-besedilo">
        Prej, ko postanete član/-ica, več točk boste zbrali in prej boste lahko uživali ugodnosti, ki jih
        te točke prinašajo!
      </p>
    </div>
    <div class="postavitev-gumb-t2-klub">
      <p>
        <span>
          <a href="/Mojprofil/T2klub">
          <el-button class="gumb-potrdi">
            T-2 KLUB
          </el-button>
          </a>
        </span>
        <span class="float-right">
          <img src="/static/img/Domov/T2klub_Logo.png" class="t2-icon-klub">
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui'
export default {
  name: 'KarticaPostaniClan',
  components: {
    [Button.name]: Button
  },
  props: {
    nazivStranke: {
      type: String,
      value: ''
    }
  }
}
</script>

<style scoped src="../../../../../../../static/css/Domov/naslovna-stran.css">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Domov/Komponente/Klub/KarticaPostaniClan.vue